import { useRequest } from 'ahooks';
import { message } from 'ssc-ui-react';

import { $gt, VueCtxRouter } from '@/common/appCtx';

import { CreateReqManager, DefaultReqManager, DeleteReqManager, EditReqManager, ReqManager } from '../api';
import { createColumns, deleteColumns, editColumns } from '../columns/common';

type BatchType = 'edit' | 'create' | 'delete';

export const useBatchType = () => {
  const query = VueCtxRouter.currentRoute.query;
  return query.type as BatchType | undefined;
};

const newReqManager = (type: BatchType | undefined): ReqManager => {
  switch (type) {
    case 'create': return new CreateReqManager();
    case 'edit': return new EditReqManager();
    case 'delete': return new DeleteReqManager();
    default: return new DefaultReqManager();
  }
};

const useTableTitle = (): string => {
  const type = useBatchType();
  switch (type) {
    case 'create': return $gt('Batch Create');
    case 'edit': return $gt('Batch Edit');
    case 'delete': return $gt('Batch Delete');
    default: return 'No title';
  }
};

const useTableRequest = () => {
  const type = useBatchType();
  const reqManager = newReqManager(type);
  const { runAsync: submitFile, loading: submitLoading } = useRequest(reqManager.submitFile, {
    manual: true,
    onSuccess() {
      message.success($gt('Succeeded!'));
      VueCtxRouter.push('/workstation-information');
    },
  });
  return {
    httpImportFile: reqManager.importFile,
    downloadRes: reqManager.downloadRes,
    submitFile,
    submitLoading,
    downloadTemplate: reqManager.downloadTemplate,
  };
};

const useTableColunmns = () => {
  const type = useBatchType();
  switch (type) {
    case 'create': return createColumns;
    case 'edit': return editColumns;
    case 'delete': return deleteColumns;
    default: return [];
  }
};

export const useTableConfigs = () => {
  const title = useTableTitle();
  const reqConfig = useTableRequest();
  const columns = useTableColunmns();
  return {
    title,
    reqConfig,
    columns,
  };
};
